export class LaunchParams {
    public LearningUnitId!: number;
    public ApplicationId!: number;
    public LearningActivityId!: number;
    public InstitutionId!: number;
    public InstitutionName!: string;
    public AuthorizationId!: string;
    public CohortId!: number;
    public CohortName!: string;
    public ConsortiumId!: number;
    public ConsortiumName!: string;
    public DocumentTarget: any;
    public ExternalSourceName: any;
    public InstitutionPurchaseId!: string;
    public LearningActivityTypeId!: number;
    public LearningUnitResourceId!: number;
    public Role!: string;
    public customParameters: any;
    public LearningSessionDetailId: any;
    public LearningUnitAttemptID: any;
    public LTIUrl!: string;
    public WaitForClosed!: string;
    public ContentProductName!: string | undefined;  // Need cookie reader for this
    public ContentProductModuleName!: string | undefined; // Need cookie reader for this
    public BookMarkLocation!: string;
    public EndTime!: Date;
    public FrameScrolling!: string;
    public IFrameStyle!: string;
    public mathMethod!: string;
    public RemediationLink!: string;
    public ResourceID!: number;
    public ResourceLocation!: string;
    public ShouldShowheader!: string;
    public StartTime!: Date;
    public UserID!: number;
    public IsLTIModule!: boolean;
    public IsRemedaition!: boolean;
    public UrlEncodeCustomParameters!: string;
    public Environment!: string;
    public IsLTITimeOutEnable!: string;
    public ResourceTypeId!: number;
}
